import { ResponseData } from '@/types/http';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { BookingApi } from '@/apis';
import { ReturnBikeResponse } from '@/types/http-payload/bike';

export default class BikeReturnStore extends BaseStore {
    bikeReturnDetail: ReturnBikeResponse | null = null;
    api: BookingApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            bikeReturnDetail: observable,
            getBikeReturn: flow.bound,
            getBeforeBikeReturn: flow.bound,
            postBikeReturn: flow.bound
        });
        this.api = new BookingApi();
    }

    *getBikeReturn(id: number | string) {
        try {
            const res: ResponseData<ReturnBikeResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getBikeReturn, id);
            if (res?.ok) {
                this.bikeReturnDetail = res?.data || null;
                return res?.data;
            }
            return false;
        } catch (error) {
        }
    }

    *getBeforeBikeReturn(id: number) {
        try {
            const res: ResponseData<ReturnBikeResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getBeforeBikeReturn, id);
            if (res?.ok) {
                this.bikeReturnDetail = res?.data || null;
                return res?.data;
            }
            return false;
        } catch (error) {
        }
    }

    *postBikeReturn(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.postBikeReturn, payload);
            if (res?.ok) {
                return true;
            }
            return false;
        } catch (error) {
        }
    }

    clean(): void {
        super.clean();
        this.bikeReturnDetail = null;
    }
}
